import React, { Component } from "react";
import PropTypes from "prop-types";
import style from "./styles";
import ProfileSection from "./ProfileSection/ProfileSection";
// import config from "lib/config";
// const backArrow = `${config.CDN_PREFIX}/static/assets/images/backArrow.png`;
// import Router from "next/router";
import MobileOnly from "../../general/components/MobileOnly";
import dynamic from "next/dynamic";
import DesktopOnly from "../../general/components/DesktopOnly";
import TabletOnly from "../../general/components/TabletOnly";

const Contactdetails = dynamic(() => import("./ContactdetailWrapper/ContactdetailWrapper"), {
  ssr: false,
});
const ProfileDetailSection = dynamic(() => import("./ProfileDetailSection/ProfileDetailSection"), {
  ssr: true,
});
const EditProfileSection = dynamic(() => import("./EditProfileSection/EditProfileSection"), {
  ssr: false,
});
const EditProfileBottom = dynamic(
  () => import("./EditProfileSection/EditProfileBottom/EditProfileBottom"),
  {
    ssr: false,
  },
);

export default class AllSectionWrapper extends Component {
  showShareModal = (m) => {
    if (this.props.showShareModal) {
      this.props.showShareModal(m);
    }
  };
  showRecommendationModal = (m) => {
    if (this.props.showRecommendationModal) {
      this.props.showRecommendationModal(m);
    }
  };
  ask_a_question_modal = (m) => {
    if (this.props.ask_a_question_modal) {
      this.props.ask_a_question_modal(m);
    }
  };
  // eslint-disable-next-line complexity
  render() {
    const {
      agentdetail,
      recommendationData,
      reviewData,
      hestiaData,
      hestiaInformation,
      showReviewModal,
      socialUpdateData,
      fetchCheckinsData,
      lang,
      langCode,
      profileData,
      query,
      clickDetectorAndScroll,
      clickDetectorData,
      socialloading,
      isUserLoggedIn,
      loginData,
    } = this.props;
    const isDotRealtor =
      query && query.isDotRealtor && JSON.parse(query.isDotRealtor) ? true : false;
    // const advertiser_id =
    //   agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.advertiser_id;
    const personName = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.person_name;
    return (
      <>
        <style jsx>{style}</style>
        <section
          className="preview-bottom-sheet-container"
          data-testid="component-allSectionWrapper">
          <div className="container">
            <div className="preview-main">
              <div id="profile_show_layout_id">
                <div id="profile-info-section">
                  <div id="about-section">
                    <div>
                      <div className="aboutSectionWrapper">
                        <div>
                          <ProfileSection
                            {...this.props}
                            query={query}
                            agentdetail={agentdetail}
                            clickDetectorData={clickDetectorData}
                            clickDetectorAndScroll={clickDetectorAndScroll}
                            reviewData={reviewData}
                            showReviewModal={showReviewModal}
                            recommendationData={recommendationData}
                            showRecommendationModal={() => this.showRecommendationModal(this.props)}
                            lang={lang}
                            loginData={loginData}
                            isUserLoggedIn={isUserLoggedIn}></ProfileSection>
                          <MobileOnly>
                            <React.Fragment>
                              <Contactdetails
                                profileData={profileData}
                                agentdetail={agentdetail}
                                query={query}
                                isUserLoggedIn={isUserLoggedIn}
                                loginData={loginData}
                                showShareModal={() => this.showShareModal(agentdetail)}
                                {...this.props}
                                lang={lang}></Contactdetails>
                              <ProfileDetailSection
                                {...this.props}
                                socialloading={socialloading}
                                agentdetail={agentdetail}
                                profileData={profileData}
                                reviewData={reviewData}
                                recommendationData={recommendationData}
                                socialUpdateData={socialUpdateData}
                                fetchCheckinsData={fetchCheckinsData}
                                hestiaData={hestiaData}
                                hestiaInformation={hestiaInformation}
                                showRecommendationModal={() =>
                                  this.showRecommendationModal(this.props)
                                }
                                ask_a_question_modal={() => this.ask_a_question_modal(this.props)}
                                showReviewModal={showReviewModal}
                                lang={lang}
                                langCode={langCode}
                                clickDetectorData={clickDetectorData}
                                isUserLoggedIn={isUserLoggedIn}
                                loginData={loginData}
                              />
                              <EditProfileSection query={query} personName={personName} />
                            </React.Fragment>
                          </MobileOnly>
                          <DesktopOnly>
                            <React.Fragment>
                              <ProfileDetailSection
                                {...this.props}
                                socialloading={socialloading}
                                agentdetail={agentdetail}
                                profileData={profileData}
                                reviewData={reviewData}
                                recommendationData={recommendationData}
                                socialUpdateData={socialUpdateData}
                                fetchCheckinsData={fetchCheckinsData}
                                hestiaData={hestiaData}
                                hestiaInformation={hestiaInformation}
                                showRecommendationModal={() =>
                                  this.showRecommendationModal(this.props)
                                }
                                ask_a_question_modal={() => this.ask_a_question_modal(this.props)}
                                showReviewModal={showReviewModal}
                                lang={lang}
                                langCode={langCode}
                                clickDetectorData={clickDetectorData}
                                isUserLoggedIn={isUserLoggedIn}
                                loginData={loginData}
                              />
                              <EditProfileSection query={query} personName={personName} />
                            </React.Fragment>
                          </DesktopOnly>
                          <TabletOnly>
                            <React.Fragment>
                              <Contactdetails
                                profileData={profileData}
                                agentdetail={agentdetail}
                                query={query}
                                isUserLoggedIn={isUserLoggedIn}
                                loginData={loginData}
                                showShareModal={() => this.showShareModal(agentdetail)}
                                {...this.props}
                                lang={lang}></Contactdetails>
                              <ProfileDetailSection
                                {...this.props}
                                socialloading={socialloading}
                                agentdetail={agentdetail}
                                profileData={profileData}
                                reviewData={reviewData}
                                recommendationData={recommendationData}
                                socialUpdateData={socialUpdateData}
                                fetchCheckinsData={fetchCheckinsData}
                                hestiaData={hestiaData}
                                hestiaInformation={hestiaInformation}
                                showRecommendationModal={() =>
                                  this.showRecommendationModal(this.props)
                                }
                                ask_a_question_modal={() => this.ask_a_question_modal(this.props)}
                                showReviewModal={showReviewModal}
                                lang={lang}
                                langCode={langCode}
                                clickDetectorData={clickDetectorData}
                                isUserLoggedIn={isUserLoggedIn}
                                loginData={loginData}
                              />
                              <EditProfileSection query={query} personName={personName} />
                            </React.Fragment>
                          </TabletOnly>
                        </div>
                        <DesktopOnly>
                          <Contactdetails
                            profileData={profileData}
                            agentdetail={agentdetail}
                            query={query}
                            isUserLoggedIn={isUserLoggedIn}
                            loginData={loginData}
                            showShareModal={() => this.showShareModal(agentdetail)}
                            {...this.props}
                            lang={lang}></Contactdetails>
                        </DesktopOnly>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* {advertiser_id ? (
                <MobileOnly>
                  <div className="footer-back-button">
                    <div className="banner_preview-back" onClick={() => Router.back()}>
                      <div className="container">
                        <div className="banner_preview-back-icon-main">
                          <div className="banner_preview-back-icon">
                            <img src={backArrow} width="40px" height="40px" alt="backArrow" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </MobileOnly>
              ) : null} */}
            </div>
          </div>
          {isDotRealtor ? (
            <EditProfileBottom query={query} personName={personName}></EditProfileBottom>
          ) : null}
        </section>
      </>
    );
  }
}

AllSectionWrapper.defaultProps = {
  isMonetizationProfile: false,
};

AllSectionWrapper.propTypes = {
  agentdetail: PropTypes.object,
  reviewData: PropTypes.array,
  socialUpdateData: PropTypes.array,
  fetchCheckinsData: PropTypes.array,
  recommendationData: PropTypes.array,
  teamProfileData: PropTypes.array,
  showShareModal: PropTypes.func,
  ask_a_question_modal: PropTypes.func,
  hestiaData: PropTypes.object,
  hestiaInformation: PropTypes.func,
  showRecommendationModal: PropTypes.func,
  showReviewModal: PropTypes.func,
  askaquestion: PropTypes.string,
  setRecommendationSuccess: PropTypes.func,
  setAskAQuestionSuccess: PropTypes.func,
  shareProfileSuccess: PropTypes.func,
  askaQuestionSuccess: PropTypes.string,
  recommendationSuccess: PropTypes.string,
  setReviewSuccess: PropTypes.func,
  reviewSuccess: PropTypes.string,
  shareStatus: PropTypes.string,
  lang: PropTypes.object,
  langCode: PropTypes.string,
  profileData: PropTypes.object,
  reviewRatingResponse: PropTypes.object,
  query: PropTypes.object,
  clickDetectorAndScroll: PropTypes.func,
  clickDetectorData: PropTypes.object,
  socialUpdatesOnClick: PropTypes.func,
  socialloading: PropTypes.bool,
  isUserLoggedIn: PropTypes.bool,
  loginData: PropTypes.object,
  isGoogleBot: PropTypes.bool,
  isMonetizationProfile: PropTypes.bool,
};
